import React, { useMemo, useState } from 'react';
import { CardElement, Elements, useElements, useStripe } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import { billingAPI } from '../services/api';

const cardElementOptions = {
  style: {
    base: {
      fontSize: '16px',
      color: '#1f2937',
      '::placeholder': {
        color: '#9ca3af'
      }
    },
    invalid: {
      color: '#dc2626'
    }
  }
};

const SetupForm = ({ onSuccess, buttonLabel }) => {
  const stripe = useStripe();
  const elements = useElements();
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!stripe || !elements) {
      return;
    }

    try {
      setSubmitting(true);
      setError('');

      const setupIntentRes = await billingAPI.createSetupIntent();
      const clientSecret = setupIntentRes.data.clientSecret;
      const cardElement = elements.getElement(CardElement);

      const result = await stripe.confirmCardSetup(clientSecret, {
        payment_method: {
          card: cardElement
        }
      });

      if (result.error) {
        throw new Error(result.error.message || 'Card setup failed.');
      }

      await billingAPI.confirmSetup({ paymentMethodId: result.setupIntent.payment_method });
      if (onSuccess) {
        await onSuccess();
      }
    } catch (err) {
      setError(err?.response?.data?.error || err.message || 'Card setup failed.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <div
        style={{
          border: '1px solid #d1d5db',
          borderRadius: 8,
          padding: '14px 16px',
          background: '#fff',
          marginBottom: 12
        }}
      >
        <CardElement options={cardElementOptions} />
      </div>
      <button type="submit" className="btn btn-primary" disabled={submitting || !stripe}>
        {submitting ? 'Saving...' : buttonLabel}
      </button>
      {error && <div style={{ color: '#dc2626', marginTop: 8 }}>{error}</div>}
    </form>
  );
};

const StripeCardSetup = ({ publishableKey, onSuccess, buttonLabel = 'Save card' }) => {
  const stripePromise = useMemo(() => (
    publishableKey ? loadStripe(publishableKey) : null
  ), [publishableKey]);

  if (!stripePromise) {
    return null;
  }

  return (
    <Elements stripe={stripePromise}>
      <SetupForm onSuccess={onSuccess} buttonLabel={buttonLabel} />
    </Elements>
  );
};

export default StripeCardSetup;
